import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Select, { SingleValue } from 'react-select';

import {
  QuestionSearch,
  SubSkill,
} from '../../../../utils/types/assessment_types';
import { SelectOptions } from '../../../../utils/types/react_select_types';

type FilterProps = {
  skillList: SelectOptions[];
  levelList: SelectOptions[];
  subSkillList: SubSkill[] | undefined;
  jobTitleList: SelectOptions[] | undefined;
  searchObject: QuestionSearch;
  setSearchObject: (searchObject: QuestionSearch) => void;
};

const customStyles = {
  container: (base: unknown) => ({
    ...(typeof base === 'object' && base ? base : {}),
    minWidth: '180px',
    width: 'clamp(180px, 16vw, 220px)',
  }),
  control: (base: unknown) => ({
    ...(typeof base === 'object' && base ? base : {}),
    minHeight: '38px',
    borderColor: '#dbe3ef',
    borderRadius: '8px',
    boxShadow: 'none',
  }),
  valueContainer: (base: unknown) => ({
    ...(typeof base === 'object' && base ? base : {}),
    padding: '2px 10px',
  }),
  placeholder: (base: unknown) => ({
    ...(typeof base === 'object' && base ? base : {}),
    color: '#64748b',
    fontSize: '13px',
  }),
  singleValue: (base: unknown) => ({
    ...(typeof base === 'object' && base ? base : {}),
    fontSize: '13px',
  }),
};

export const QuestionsFilter: React.FC<FilterProps> = ({
  skillList,
  levelList,
  subSkillList,
  jobTitleList,
  searchObject,
  setSearchObject,
}) => {
  const [subSkills1, setSubSkills1] = useState<SelectOptions[]>();
  const [subSkills2, setSubSkills2] = useState<SelectOptions[]>();
  const [subSkills3, setSubSkills3] = useState<SelectOptions[]>();

  const returnSubSkills = (parent: string | undefined) => {
    const subSkills: SelectOptions[] = [];
    subSkillList?.forEach((subSkill: SubSkill) => {
      if (subSkill.parentSkillId === parent) {
        subSkills.push({ label: subSkill.subskillName, value: subSkill.id });
      }
    });

    return subSkills;
  };

  const handleSelectChange = (
    selectedValue: SingleValue<SelectOptions>,
    action: { name?: string },
  ) => {
    if (action.name === 'skillId') {
      if (selectedValue) {
        setSubSkills1(() => returnSubSkills(selectedValue.value));
      }
      setSubSkills2([]);
      setSubSkills3([]);
      setSearchObject({
        ...searchObject,
        [action.name]: selectedValue ? selectedValue.value : '',
        subSkill1Id: '',
        subSkill2Id: '',
        subSkill3Id: '',
      });
    } else if (action.name === 'subSkill1Id') {
      if (selectedValue) {
        setSubSkills2(() => returnSubSkills(selectedValue.value));
      }
      setSubSkills3([]);
      setSearchObject({
        ...searchObject,
        [action.name]: selectedValue ? selectedValue.value : '',
        subSkill2Id: '',
        subSkill3Id: '',
      });
    } else if (action.name === 'subSkill2Id') {
      if (selectedValue) {
        setSubSkills3(() => returnSubSkills(selectedValue.value));
      }
      setSearchObject({
        ...searchObject,
        [action.name]: selectedValue ? selectedValue.value : '',
        subSkill3Id: '',
      });
    } else if (action.name) {
      setSearchObject({
        ...searchObject,
        [action.name]: selectedValue ? selectedValue.value : '',
      });
    }
  };

  return (
    <Box sx={{ display: 'flex', minWidth: 0, flex: 1, flexWrap: 'wrap', alignItems: 'center', gap: 1, py: 0.5 }}>
      <Select
        placeholder="Select Skill"
        name="skillId"
        options={skillList}
        onChange={handleSelectChange}
        isClearable={true}
        styles={customStyles}
      />
      {searchObject.skillId !== null && searchObject.skillId.length > 0 && (
        <Select
          placeholder="Select Sub-Skill 1"
          name="subSkill1Id"
          options={subSkills1}
          onChange={handleSelectChange}
          isClearable={true}
          styles={customStyles}
        />
      )}
      {searchObject.subSkill1Id.length > 0 && (
        <Select
          placeholder="Select Sub-Skill 2"
          name="subSkill2Id"
          options={subSkills2}
          onChange={handleSelectChange}
          isClearable={true}
          styles={customStyles}
        />
      )}
      {searchObject.subSkill2Id.length > 0 && (
        <Select
          placeholder="Select Sub-Skill 3"
          name="subSkill3Id"
          options={subSkills3}
          onChange={handleSelectChange}
          isClearable={true}
          styles={customStyles}
        />
      )}
      <Select
        placeholder="Select Skill Level"
        name="levelId"
        options={levelList}
        onChange={handleSelectChange}
        isClearable={true}
        styles={customStyles}
      />
      <Select
        placeholder="Select Job Title"
        name="jobTitle"
        options={jobTitleList}
        onChange={handleSelectChange}
        isClearable={true}
        styles={customStyles}
      />
    </Box>
  );
};
